import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';


export default {
    getDailyReport(params) {
        return Api()
            .get('/api/production_reports/daily_production', {params: params})
            .catch((err) => errorHandler(err, null));
    },
    getProjectDashboard(params) {
        return Api()
            .get('/api/production_reports/project_dashboard', {params: params})
            .catch((err) => errorHandler(err, null));
    },
    getProjectSelector(params) {
        return Api()
            .get('/api/production_reports/project_selector', {params: params})
            .catch((err) => errorHandler(err, null));
    },
    getProjectDashboardProjects() {
        return Api()
            .get('/api/production_reports/project_dashboard/projects')
            .catch((err) => errorHandler(err, null));
    },
    addProjectDashboardProject(projectId) {
        return Api()
            .post('/api/production_reports/project_dashboard/projects', {projectId})
            .catch((err) => errorHandler(err, null));
    },
    replaceProjectDashboardProjects(projectIds) {
        return Api()
            .put('/api/production_reports/project_dashboard/projects', {projectIds})
            .catch((err) => errorHandler(err, null));
    },
    deleteProjectDashboardProject(projectId) {
        return Api()
            .delete(`/api/production_reports/project_dashboard/projects/${projectId}`)
            .catch((err) => errorHandler(err, null));
    },
    syncClockify() {
        return Api()
        .get('/api/production_reports/sync_clockify')
        .catch((err) => errorHandler(err, null));
    },

}
